// extracted by mini-css-extract-plugin
export default {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","button":"NBN87","flexContainer":"f9OtK","count":"D8H8+","switchCounterAndButton":"QVOBD"};